import React from 'react'
import { TextField, Grid, FormControl, InputAdornment, Autocomplete } from '@mui/material';

const CurrencyInput = ({currencyList, selectedCurrency, cost, cb}) => {
    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={6}>
                <FormControl fullWidth>
                    <Autocomplete
                        disablePortal
                        includeInputInList={false}
                        clearIcon={false}
                        value={selectedCurrency || {id: '', currency_name: '', currency_symbol: ''}}
                        options={currencyList}
                        sx={{ width: '100%' }}
                        getOptionLabel={(currencyList) =>
                            currencyList.currency_name
                        }
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label='Divisa'
                                inputProps={{
                                    ...params.inputProps,
                                }}
                                required={true}
                            />
                        )}
                        onChange={(e, value) => {
                            cb.handleCurrencyChange(value);
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={6}>
                <TextField
                    fullWidth
                    required
                    label="Costo"
                    type='number'
                    value={cost || ''}
                    onChange={(e) => cb.handleCostChange(e.target.value)}
                    InputProps={{
                        startAdornment: <InputAdornment position='start'>{selectedCurrency?.currency_symbol || ''}</InputAdornment>
                    }}
                />
            </Grid>
        </Grid>
    )
}

export default CurrencyInput